import React from "react"
import ContentLoader from "react-content-loader"
import {IMAGE_MODE} from "../../../constants/imageMode";
import './styles.scss';

const Skeleton = ({
  classNameProps,
  imageMode,
  width,
  height,
  textMode = false,
  backgroundColorOne,
  backgroundColorTwo
}) => {


  const contentSkeleton = {
    speed: 2,
    backgroundColor: backgroundColorOne,
    foregroundColor: backgroundColorTwo,
  }

  const imageSkeleton = {
    height,
    width,
  }

  const titleSkeleton = {
    width: '35%',
    height: (height / 100) * ((imageMode === 'POSTER') ? 5 : 10),
  }

  const subTitleSkeleton = {
    width: '50%',
    height: (height / 100) * ((imageMode === 'POSTER') ? 5 : 10),
  }


  return (
    <div className={classNameProps + ' carouselSkeletonContainer__' + imageMode} >
      <ContentLoader viewBox={`0 0 ${width} ${height}`} className='carouselSkeletonImage' {...contentSkeleton} preserveAspectRatio="none">
        <rect {...imageSkeleton} />
      </ContentLoader>
      {(textMode !== "none") && imageMode !== IMAGE_MODE.SIMPLE_LARGE &&
        <ContentLoader viewBox={`0 0 ${width} ${titleSkeleton.height}`} className='carouselSkeletonTitle' {...contentSkeleton}>
          <rect {...titleSkeleton} />
        </ContentLoader>}
      {((textMode !== "none") && imageMode === IMAGE_MODE.THUMB) && imageMode !== IMAGE_MODE.SIMPLE_LARGE &&
        <ContentLoader viewBox={`0 0 ${width} ${subTitleSkeleton.height}`} className='carouselSkeletonSubTitle' {...contentSkeleton}>
          <rect {...subTitleSkeleton} />
        </ContentLoader>}
    </div>
  )
}

export default Skeleton;